import React, { createRef } from "react";
import { NSColumn, NSBoxEnum, NSBoxString, NSBox } from "namirasoft-site-react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerEntities } from "../JobArrangerEntities";
import { ReasonStatus, ReasonInputRow, ReasonRow } from "namirasoft-job-arranger";

interface ReasonEditPageProps extends NSARouterMakerResult, JobArrangerProps
{
	isEdit: boolean;
}

export default class ReasonEditPage extends React.Component<ReasonEditPageProps>
{
	NSBoxString_Name = createRef<NSBoxString>();
	NSBoxEnum_Status = createRef<NSBoxEnum<ReasonStatus>>();

	override render()
	{
		return (
			<JobArrangerLayout<ReasonRow, ReasonInputRow>
				{...this.props}
				pages={{
					entity: JobArrangerEntities.reason(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let name: string = this.NSBoxString_Name.current?.getValue() ?? "";
										let status: ReasonStatus = this.NSBoxEnum_Status.current?.getValueEnumOne(ReasonStatus, ReasonStatus.WhiteList) ?? ReasonStatus.WhiteList;
										return {
											workspace_id: "",
											name,
											status,
											reason_category: [],
											reason_field: [],
											reason_tag: [],
										};
									},
									setRow: (row) =>
									{
										this.NSBoxString_Name.current?.setValue(row.name);
										this.NSBoxEnum_Status.current?.setValue(row.status);
									}
								}
							}
						}
					}
				}}
			>
				<NSColumn>
					<NSBoxString
						ref={this.NSBoxString_Name}
						required
						title="Name"
						style={{ width: NSBox.width.double }}
						info={{ link: "https://namirasoft.com/job-arranger/console-guide/reason/#field-name" }}
					/>
					<NSBoxEnum<ReasonStatus>
						ref={this.NSBoxEnum_Status}
						required
						title="Status"
						getEnumObject={() => ReasonStatus}
						multiple={false}
						style={{ width: NSBox.width.double }}
						info={{ link: "https://namirasoft.com/job-arranger/console-guide/reason/#field-status" }}
					/>
				</NSColumn>
			</JobArrangerLayout >
		);
	}
}